import { useCallback, useEffect, useState } from 'react';

export const useTemperatureUnit = () => {
    const [unit, setUnit] = useState(() => localStorage.getItem('tempUnit') || 'C');

    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'tempUnit') setUnit(e.newValue);
        };
        const handleCustomEvent = (e) => {
            setUnit(e.detail);
        };
        
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('tempUnitChange', handleCustomEvent);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('tempUnitChange', handleCustomEvent);
        };
    }, []);

    const setTemperatureUnit = useCallback((nextUnit) => {
        if (nextUnit !== 'C' && nextUnit !== 'F') return;
        localStorage.setItem('tempUnit', nextUnit);
        setUnit(nextUnit);
        window.dispatchEvent(new CustomEvent('tempUnitChange', { detail: nextUnit }));
    }, []);

    const toggleUnit = useCallback(() => {
        setTemperatureUnit(unit === 'C' ? 'F' : 'C');
    }, [setTemperatureUnit, unit]);

    return { unit, toggleUnit, setTemperatureUnit };
};
